(function () {
    "use strict";

    angular.module("app").controller("ActionBarController", ActionBarController);
    ActionBarController.$inject = ["$scope", "actionbarService"];
    function ActionBarController($scope, actionBarService) {

        $scope.isloading = true;
        $scope.ispartlyloading = true;
        $scope.isAllowed = true;

        $scope.previousClick = function () {
            actionBarService.previousClick();
        };

        $scope.nextClick = function () {
            actionBarService.nextClick();
        };

        $scope.saveClick = function (jqEvent) {
            actionBarService.saveClick(jqEvent);
        };

        $scope.acceptedClick = function (jqEvent) {
            actionBarService.acceptedClick(jqEvent);
        };

        $scope.addResultClick = function () {
            actionBarService.AddResultClick();
        };

        $scope.returnClick = function (jqEvent) {
            actionBarService.returnClick(jqEvent);
        };

        $scope.extractClick = function (jqEvent) {
            actionBarService.extractClick(jqEvent);
        };

        $scope.closeClick = function () {
            actionBarService.closeClick();
        };

        $scope.toStatus = function () {
            actionBarService.toStatus();
        };

        // add event that listens to scope changes
        // enable/disable buttonsntroller
        $scope.$on("request_stateChanged", function (_event, isloading, ispartlyloading) {
            $scope.isloading = isloading;
            $scope.ispartlyloading = ispartlyloading;
        });

        // add event that listens to scope changes
        // enable/disable buttonsntroller
        $scope.$on("request_stateChangedTo", function (_event, isAllowed) {
            $scope.isAllowed = isAllowed;
        });

        $scope.$on("request_stateCanAccept", function (_event, canAccept) {
            $scope.canAccept = canAccept;
        });

        $scope.$on("request_stateCanReturn", function (_event, canReturn) {
            $scope.canReturn = canReturn;
        });

        $scope.$on("request_buttonVisibilityChange", updateButtonVisibility);

        function updateButtonVisibility(_event, isAcceptButtonVisible, isAddResultButtonVisible) {
            $scope.isAcceptButtonVisible = isAcceptButtonVisible;
            $scope.isAddResultButtonVisible = isAddResultButtonVisible;
        }

        $scope.$on("request_CanInteractWithPersons", function (_event, canInteractWithPersons) {
            $scope.CanInteractWithPersons = canInteractWithPersons;
        });

        $scope.$on("Auto_Next", function () {
            actionBarService.nextClick();
        });

        $scope.$on("Auto_Prev", function () {
            actionBarService.previousClick();
        });

        $scope.$on("ToStatus", function () {
            actionBarService.toStatus();
        });

    }
})();
